export default __webpack_public_path__ + "static/media/uac_logo.a8999358.svg";